var React = require('react');

function Catering (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill: #000;\n        stroke-width: 0px;\n      }\n    ")),React.createElement("path",{"className":"cls-1","d":"M65.9,36.7c.9-3.9,2.9-7.4,5.7-10.3l-4.7-4.7c-2.7,2.7-4.8,6-6.3,9.6l2.7-15.1-6.6-1.2-3.4,19.5V10h-6.7v22.7l-1.7-19.4-6.6.6,1.5,17.5c-2-3.2-4.6-6-7.7-8.1l-3.8,5.5c2.9,2.1,5.3,4.8,6.9,7.9h-8.5l6.7,53.3h33.3l6.7-53.3h-7.4ZM60.8,83.3h-21.6l-1.5-12.2c3,2.4,7.4,3.9,12.3,3.9s9.3-1.5,12.3-3.9l-1.5,12.2ZM40,63.3c0-2,4-5,10-5s10,3,10,5-4,5-10,5-10-3-10-5ZM64.1,57.1c-3-3.3-8.1-5.5-14.1-5.5s-11.1,2.2-14.1,5.5l-1.7-13.8h31.6l-1.7,13.8Z","key":1})]);
}

Catering.defaultProps = {"id":"Layer_1","data-name":"Layer 1","version":"1.1","viewBox":"0 0 100 100","width":"100","height":"100"};

module.exports = Catering;

Catering.default = Catering;
